import React from 'react'
import PropTypes from 'prop-types'
import initialStates from './initialState'
import GlobalReducer from './reducer'
// import { store } from 'src/store'

export const GlobalContext = React.createContext();

export default function GlobalProvider({ children }) {
  const [state, dispatch] = React.useReducer(GlobalReducer, initialStates)

  return <GlobalContext.Provider value={{ state, dispatch }}>{children}</GlobalContext.Provider>
}

GlobalProvider.propTypes = {
  children: PropTypes.element,
}
GlobalProvider.defaultProps = {
  children: <div></div>,
}
